import {
  routerOrderGetData,
  routerOrderAddOneData,
  routerOrderUpdateOne,
  routerOrderDeleteData
} from '@/api/api'

import {
  tableSortDatas
} from '@/fm-table/lib/sort_list'

import {
  dataListFilter
} from '@/fm-table/lib/tools'

const state = {
  planOrderList: [],
  basePlanOrderList: [],
  planOrderSearchParm: {},
  planOrderSortParm: {}
}

const getters = {
  planOrderList: state => state.planOrderList,
  basePlanOrderList: state => state.basePlanOrderList,
  planOrderSearchParm: state => state.planOrderSearchParm,
  planOrderSortParm: state => state.planOrderSortParm
}

let dealData = function (data, oilDensity) {
  data.forEach((item) => {
    let itemOilDensity = (!item.oilName || item.oilName.includes('柴油')) ? oilDensity.cy : oilDensity.qy
    item.sendTime = item.sendTime.slice(0, 10)
    item.jjd = item.emptyHour < 6 ? '急' : (item.emptyHour < 18 ? '先' : '')
    item.oilNameJ = item.oilName ? item.oilName.split('号')[0] + '#' : ''
    item.carCabinNo = String(item.carCabinNo)
    item.volumeD = item.volume ? (item.volume / 1000 * itemOilDensity).toFixed(2) : ''
  })
  return data
}

const actions = {
  loadPlanOrderList ({ dispatch, getters }, parm) {
    return routerOrderGetData(parm).then((data) => {
      dispatch('setBasePlanOrderList', dealData(data, getters.oilDensity))
      dispatch('dealPlanOrderList')
    })
  },
  setPlanOrderList ({ commit }, data) {
    commit('setPlanOrderList', data)
  },
  setBasePlanOrderList ({ commit }, data) {
    commit('setBasePlanOrderList', data)
  },
  addPlanOrder ({ commit, getters }, {data, copyId}) {
    // 若是新增，则放在第一个，若是copy 放在后面一个
    return routerOrderAddOneData(data).then((dataNew) => {
      if (copyId) {
        commit('addCopyPlanOrder', {data: dealData(dataNew, getters.oilDensity)[0], copyId})
        commit('addCopyBasePlanOrder', {data: dealData(dataNew, getters.oilDensity)[0], copyId})
      } else {
        commit('addPlanOrder', dealData(dataNew, getters.oilDensity)[0])
        commit('addBasePlanOrder', dealData(dataNew, getters.oilDensity)[0])
      }
    })
  },
  delPlanOrder ({ commit }, data) {
    return routerOrderDeleteData(data.id).then(() => {
      commit('delPlanOrder', data)
      commit('delBasePlanOrder', data)
    })
  },
  updatePlanOrder ({ commit, getters }, data) {
    routerOrderUpdateOne(data).then((dataNew) => {
      dataNew[0].strand = data.strand
      commit('updatePlanOrder', dealData(dataNew, getters.oilDensity)[0])
      commit('updateBasePlanOrder', dealData(dataNew, getters.oilDensity)[0])
    })
  },
  dealPlanOrderList ({ dispatch, getters }) {
    let data = getters.basePlanOrderList
    data = dataListFilter(data, getters.planOrderSearchParm.searchMap, getters.planOrderSearchParm.searchConfig)
    data = tableSortDatas(data, getters.planOrderSortParm.relationSort, getters.planOrderSortParm.sortMap, getters.planOrderSortParm.sortConfig)
    dispatch('setPlanOrderList', data)
  },
  setPlanOrderSearchParm ({ commit, dispatch }, data) {
    commit('setPlanOrderSearchParm', data)
    dispatch('dealPlanOrderList')
  },
  setPlanOrderSortParm ({ commit, dispatch }, data) {
    commit('setPlanOrderSortParm', data)
    dispatch('dealPlanOrderList')
  }
}

const mutations = {
  setPlanOrderSortParm (state, data) {
    state.planOrderSortParm = data
  },
  setPlanOrderSearchParm (state, data) {
    state.planOrderSearchParm = data
  },
  setPlanOrderList (state, data) {
    state.planOrderList = data
  },
  setBasePlanOrderList (state, data) {
    state.basePlanOrderList = data
  },
  addPlanOrder (state, data) {
    state.planOrderList = [data].concat(state.planOrderList)
  },
  addBasePlanOrder (state, data) {
    state.basePlanOrderList = [data].concat(state.basePlanOrderList)
  },
  addCopyPlanOrder (state, {data, copyId}) {
    let newData = []
    state.planOrderList.forEach((item) => {
      newData.push(item)
      if (item.id === copyId) {
        newData.push(data)
      }
    })
    state.planOrderList = newData
  },
  addCopyBasePlanOrder (state, {data, copyId}) {
    let newData = []
    state.basePlanOrderList.forEach((item) => {
      newData.push(item)
      if (item.id === copyId) {
        newData.push(data)
      }
    })
    state.basePlanOrderList = newData
  },
  delPlanOrder (state, data) {
    let newData = []
    state.planOrderList.forEach((item) => {
      if (item.id !== data.id) {
        newData.push(item)
      }
    })
    state.planOrderList = newData
  },
  delBasePlanOrder (state, data) {
    let newData = []
    state.basePlanOrderList.forEach((item) => {
      if (item.id !== data.id) {
        newData.push(item)
      }
    })
    state.basePlanOrderList = newData
  },
  updatePlanOrder (state, data) {
    let newData = []
    state.planOrderList.forEach((item) => {
      if (item.id === data.id) {
        newData.push(data)
      } else {
        newData.push(item)
      }
    })
    state.planOrderList = newData
  },
  updateBasePlanOrder (state, data) {
    let newData = []
    state.basePlanOrderList.forEach((item) => {
      if (item.id === data.id) {
        newData.push(data)
      } else {
        newData.push(item)
      }
    })
    state.basePlanOrderList = newData
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/plan_order_edit.js